var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"points-counter"},[_c('strong',{staticClass:"points-counter__number"},[_vm._v(_vm._s(_vm.$store.state.credits))]),_c('lion-coin',{staticClass:"points-counter__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }